/* src/app/components/travelcost-simulator/travelcost-simulator.component.css */
.alert {
  position: relative;
}
.close {
  position: absolute;
  right: 10px;
  top: 10px;
}
/*# sourceMappingURL=travelcost-simulator.component.css.map */
